export default function addItemXTimes(item, order, quantity) {
  const newOrder = [...order];
  for (let i = 0; i < quantity; i += 1) newOrder.push(item);
  return newOrder;
}
